import { render, staticRenderFns } from "./wode-zhanghu.vue?vue&type=template&id=12cf884e&"
import script from "./wode-zhanghu.vue?vue&type=script&lang=js&"
export * from "./wode-zhanghu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports